var map = {
	"./foodtype-american.png": "c40c",
	"./foodtype-bbq.png": "119c",
	"./foodtype-chinese.png": "0862",
	"./foodtype-english.png": "a42b",
	"./foodtype-french.png": "6ca3",
	"./foodtype-italian.png": "4648",
	"./foodtype-mexican.png": "7515"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "371b";